var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelineSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 0C24.625 0 0 24.625 0 55C0 85.375 24.625 110 55 110C85.375 110 110 85.375 110 55C110 24.625 85.375 0 55 0ZM78.84 45.7C79.279 45.1982 79.6132 44.6137 79.8229 43.9808C80.0327 43.348 80.1137 42.6796 80.0614 42.0149C80.009 41.3503 79.8242 40.7028 79.5179 40.1106C79.2116 39.5185 78.7899 38.9935 78.2777 38.5667C77.7656 38.1399 77.1732 37.8198 76.5355 37.6253C75.8978 37.4308 75.2276 37.3658 74.5644 37.4341C73.9012 37.5025 73.2584 37.7027 72.6737 38.0232C72.0891 38.3436 71.5744 38.7777 71.16 39.3L49.66 65.095L38.535 53.965C37.592 53.0542 36.329 52.5502 35.018 52.5616C33.707 52.573 32.4529 53.0989 31.5259 54.0259C30.5989 54.9529 30.073 56.207 30.0616 57.518C30.0502 58.829 30.5542 60.092 31.465 61.035L46.465 76.035C46.9563 76.526 47.5445 76.9092 48.1921 77.1603C48.8397 77.4114 49.5325 77.5248 50.2263 77.4932C50.9202 77.4617 51.5999 77.286 52.2221 76.9772C52.8442 76.6685 53.3953 76.2335 53.84 75.7L78.84 45.7Z",
    fill: "#6B7AE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineSuccess);
export default __webpack_public_path__ + "static/media/timeline-success.e2c7c010d606af5976f809873224f403.svg";
export { ForwardRef as ReactComponent };